import { useState, useMemo } from 'react';

export const useDeadlineFilter = (orders) => {
  const [selectedYear, setSelectedYear] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const filteredOrders = useMemo(() => {
    let result = [...orders];

    if (selectedYear) {
      result = result.filter((order) => {
        const deadline = new Date(order.deadline);
        return deadline.getFullYear() === selectedYear;
      });
    } else if (startDate || endDate) {
      result = result.filter((order) => {
        const deadline = new Date(order.deadline);
        return (
          (!startDate || deadline >= new Date(startDate)) &&
          (!endDate || deadline <= new Date(endDate))
        );
      });
    }

    return result;
  }, [orders, selectedYear, startDate, endDate]);

  return {
    filteredOrders,
    selectedYear,
    setSelectedYear,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  };
};
